import request from '@/utils/request'
// 待办工单后处理
/**
 *
 * @param {*} data  operatorEnum：1 已知晓 2代表修改复诊日期 businessData；
 *                  businessEnum：DA_CURE_RESERVE_ORDER ;taskId:任务ID；
 *                  operatorName：操作人名字
 * @returns
 */
export function apiSubTaskHandle(data) {
  return request({
    url: '/health-doctor-assistant/subTask/handle',
    method: 'post',
    data
  })
}

// 复诊提醒工单列表
/**
 *
 * @param {*} data  workOrderId：待办工单id
                    subTaskBusinessType：DA_CURE_RESERVE_ORDER
 * @returns
 */
export function apiSubTaskReserveQuery(data) {
  return request({
    url: '/health-doctor-assistant/subTask/reserve/query',
    method: 'get',
    params: data
  })
}
// 根据预约单ID修改子待办状态
export function apiSubTaskReserveUpdate(data) {
  return request({
    url: '/health-doctor-assistant/subTask/update',
    method: 'post',
    data
  })
}

// 锦旗详情
export function apiReverseDateList(data) {
  return request({
    url: '/health-cure/cure/reserve/listDays',
    method: 'get',
    params: data
  })
}
// 根据月份查询是否有预约单标签
export function queryCureReserveTag(data) {
  return request({
    url: '/health-cure/cure/reserve/queryCureReserveTag',
    method: 'post',
    data
  })
}

export function apiDayReverseInfo(data) {
  return request({
    url: '/health-cure/cure/reserve/v2/list',
    method: 'get',
    params: data
  })
}

export function apiEffectiveScanSelectRecordOld(data) {
  return request({
    url: '/health-cure/reserve/action/record/getEffectiveScanSelectRecord',
    method: 'post',
    data
  })
}

export function apiEffectiveScanSelectRecord(data) {
  return request({
    url: '/health-cure/reserve/action/record/getWriteOffReserveRecord',
    method: 'post',
    data
  })
}

// 修改预约单状态
export function apiConfirmReversed(data) {
  return request({
    url: '/health-cure/cure/reserve/reversedConfirm',
    method: 'post',
    data
  })
}

// 判定有效扫码
export function apiEffectiveScanAuditOld(data) {
  return request({
    url: '/health-finance/effective/scan/doctorAssistantEffectiveScanAudit',
    method: 'post',
    data
  })
}

export function apiEffectiveScanAudit(data) {
  return request({
    url: '/health-cure/cure/reserve/cancelReserveByWorkOrder',
    method: 'post',
    data
  })
}

export function apiGetAllUnRevisitReason(data) {
  return request({
    url: '/health-cure/cure/reserve/getAllUnRevisitReason',
    method: 'get',
    params: data
  })
}

export function apiSubmitReason(data) {
  return request({
    url: '/health-cure/cure/reserve/recordUnRevisitReason',
    method: 'post',
    data
  })
}

// 根据业务id和类型查询复诊预约单
export function apiGetCureRevrseByBusiness(data) {
  return request({
    url: '/health-cure/cure/reserve/getCureReserveByBusinessTypeAndId',
    method: 'get',
    params: data
  })
}

export function apiOrderOperateHistory(data) {
  return request({
    url: '/health-doctor-assistant/operationRecord/save',
    method: 'post',
    data
  })
}
// 获取复诊提醒工单子任务状态
export function subTaskStatus(data) {
  return request({
    url: '/health-doctor-assistant/subTask/status/query',
    method: 'get',
    params: data
  })
}

// 查询还未核销的预约单信息
export function queryCureReserveVO(data) {
  return request({
    url: '/health-cure/cure/reserve/queryCureReserveVO',
    method: 'get',
    params: data
  })
}

// 查询还未核销的预约单信息
export function searchPatientFollowDays(data) {
  return request({
    url: '/health-cure/cure/re-consult-remind/follow/day',
    method: 'get',
    params: data
  })
}

// 查询预约单限制和系统推荐日期
export function queryLimitAndDefaultDate(data) {
  return request({
    url: '/health-cure/cure/reserve/queryLimitAndDefaultDate',
    method: 'get',
    params: data
  })
}

// 查询预约单限制和系统推荐日期
export function isDoctorJoinProject(data) {
  return request({
    url: '/health-user/activityProject/observation/doctorJoin',
    method: 'get',
    params: data
  })
}
